<template>
    <div class="ngdialog-content">
        <dialog-header>
            <h4>{{ $t('systems.edit_header_data') }}</h4>
        </dialog-header>

        <form name="changeHeadForm" novalidate @submit.prevent="submit()">
            <div class="ngdialog__body">
                <fieldset class="form__group">
                    <system-form-base
                        ref="systemBase"
                        :name.sync="formData.name"
                        :address1.sync="formData.address1"
                        :address2.sync="formData.address2"
                        :postcode.sync="formData.postcode"
                        :city.sync="formData.city"
                        :region.sync="formData.region"
                        :country.sync="formData.country"
                        :system_status.sync="formData.system_status"
                        :boiler_image_name.sync="formData.boiler_image_name"
                        :remote-errors.sync="remoteErrors"
                        :available-boilers.sync="system.available_boiler_images"
                    />

                    <div class="form__row" v-if="$can('change group', system)">
                        <label class="form__label" for="group_id">{{ $t('fields.group') }}</label>
                        <group-select
                            class="form__field"
                            id="group_id"
                            name="group_id"
                            v-model="formData.group_id"
                            filter="accessible_groups"
                        ></group-select>
                    </div>
                </fieldset>
            </div>

            <dialog-buttons :submit-text="$t('buttons.save_changes')" />
        </form>
    </div>
</template>

<script>
import forEach from 'lodash/forEach';
import * as api from '@/api';
import SystemFormBase from '@/components/SystemFormBase';
import DialogHeader from '@/components/DialogHeader';
import DialogButtons from '@/components/DialogButtons';
import GroupSelect from '@/components/GroupSelect';

export default {
    name: 'system-change-head',
    components: {
        SystemFormBase,
        DialogHeader,
        DialogButtons,
        GroupSelect,
    },
    props: {
        system: {
            type: Object,
            required: true,
        },
        successCallback: {
            type: Function,
        },
    },
    data() {
        let data = {
            formData: {
                ownerEmail: '',
                name: '',
                address1: '',
                address2: '',
                postcode: '',
                city: '',
                region: '',
                country: '',
                system_status: '',
                boiler_image_name: '',
            },
            remoteErrors: null,
        };

        if (this.$can('change group', this.system)) {
            data.formData.group_id = '';
        }

        return data;
    },
    created() {
        forEach(this.formData, (value, key) => {
            if (this.system[key] !== null && this.system[key] !== undefined) {
                this.formData[key] = this.system[key];
            }
        });
    },
    methods: {
        submit() {
            this.remoteErrors = null;

            if (this.$refs.systemBase.$v.$invalid) {
                this.$refs.systemBase.$v.$touch();
                return;
            }

            api.systems.update({ id: this.system.id, data: this.formData }).then(
                () => {
                    if (this.successCallback) {
                        this.successCallback();
                    }

                    this.$emit('close');
                },
                error => {
                    this.remoteErrors = error.response.errors;
                }
            );
        },
    },
};
</script>
